import { createApis } from 'saga-slice-helpers';
import { API_TIMEOUT } from '../../constants';
import { returnMSTeamsApi } from './utils';
// import { checkForUnauthorized, returnMSTeamsApi } from './utils';
import { getSessionToken } from '../app/utils';

const { api } = createApis({
  baseURL: returnMSTeamsApi(),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: API_TIMEOUT,
});

api.instance.interceptors.request.use(
  (config) => {
    const token = getSessionToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    // return await checkForUnauthorized(err);
    throw new Error(err);
  },
);

export default api;
